function getParam(param) {
    param = encodeURIComponent(param)
    let regexp = new RegExp( '[&?]'+param+'=([^&]*)' )
    let matches = regexp.exec(location.search)
    if ( matches ) {
        return decodeURIComponent(matches[1])
    }
    return undefined
}
export { getParam }